<template>
  <div class="activityList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>专业观众免费参观证</el-breadcrumb-item>
    </el-breadcrumb>
    <p style="font-size: 14px; margin: 10px 0; width: 80%;">由于9/16日起，上海国际乐器展将进入收费阶段，且参展商VIP观众嘉宾邀请的数量有限，主办方特此为每家参展商提供邀请码以便参展商邀请更多专业观众入场。受邀观众凭展商邀请码至官方微信或小程序完成注册及实名认证，即可免费参观展会。贵司邀请码为 <b style="color: red;">{{ userInfo.atrLevel }}</b>，使用次数有限，请妥善发送，用完即止。</p>
    <div class="tipVIP" style="margin: 10px 0; width: 80%; display: none;">
      <p style="font-size: 14px;">由于展会现场观众入场收费，VIP观众嘉宾邀请的数量限制，主办方根据参展商展位面积的大小给予一定数量的专业观众胸卡申请的名额，主办单位将根据展商填写的信息对贵司客户进行注册，并于展前向贵司客户手机发送参观确认码，受邀的客户在展会现场可以凭借参观确认码换取专业观众胸卡后入场参观。</p>
      <p style="font-size: 14px;"><strong>由于一张胸卡对应一个手机号，请申请时注意填写的手机不要重复。</strong></p>
      <p style="font-size: 14px;">☆专业观众免费参观证（及专业观众胸卡）数量资格表：</p>
      <table class="areaClass">
        <tr>
          <td width="150px">展位面积</td>
          <td width="250px">专业观众胸卡申请数限制</td>
        </tr>
        <tr>
          <td>50平米以下</td>
          <td>30张</td>
        </tr>
        <tr>
          <td>50-100平米</td>
          <td>50张</td>
        </tr>
        <tr>
          <td>100平米以上</td>
          <td>100张</td>
        </tr>
      </table>
    </div>
    <div style="font-size: 14px; display: none;">您最多可以邀请重要客户数为：<span style="color: red;font-weight: bold;">{{this.num}}</span>个。已经邀请了<span style="color: red; font-weight: bold;">{{this.total}}</span>个，剩余邀请数量为<span style="color: red;font-weight: bold;">{{this.sytotal}}</span>个。</div>
    <div class="operas" style="display: none;">
      <el-button type="primary" @click="addCard">新增</el-button>
    </div>
    <el-table
      v-if="isPC"
      :data="tableData"
      style="width: 100%;display: none;">
      <el-table-column
        prop="psjName"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="psjComName"
        label="公司名">
      </el-table-column>
      <!-- <el-table-column
        label="头像"
        width="160">
        <template slot-scope="scope">
          <img style="max-height:100px;" :src="scope.row.photo"/>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="psjIDCard"
        label="身份证号">
      </el-table-column>
      <el-table-column
        prop="psjRank"
        label="职位">
      </el-table-column>
      <el-table-column
        label="操作"
        width="160">
        <template slot-scope="scope">
          <el-button @click="editCard(scope.row)" type="text" size="small" v-if="scope.row.tktZipCode!='en'">修改</el-button>
          <el-button @click="deletCard(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="cards">
      <li v-for="(val) in tableData" :key="val.id">
        <div :body-style="{ padding: '0px' }" class="cardItem">
          <div class="img"><img :src="val.photo"></div>
          <div class="rightBox">
            <p>姓名： {{val.tktName}}</p>
            <p>公司名： {{val.tktComName}}</p>
            <p>身份证号： {{val.tktIDCard}}</p>
            <p>职位： {{val.tktRank}}</p>
            <div class="bottom clearfix">
              <el-button class="button" type="primary" @click="editCard(val)">修改</el-button>
              <el-button class="button" @click="deletCard(val)">删除</el-button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import api from '@/api'
import reg from '@/utils/regExp'
import tools from '../../utils/tools.js';
export default {
  name: 'card',
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      tableData: [],
      isPC: true,
      num:'',
      total:'',
      sytotal:'',
      bthArea:''
    }
  },
  mounted() {
    this.isPC = tools.isPC()
    this.getTicket()
    this.bthArea = Math.round(sessionStorage.getItem('bthArea'))
    if(this.bthArea < 50){
      this.num = 30
    }else if(this.bthArea >= 50 && this.bthArea <= 100){
      this.num = 50
    }else if(this.bthArea > 100){
      this.num = 100
    }
  },
  methods: {
    addCard() {
      if(this.sytotal <= 0){
        this.$notify({
          title: '提示',
          message: '您可邀请的人数已达上限,暂时无法新增',
          type: 'warning'
        });
      }else{
        this.$router.push({path: '/addzygz', query: {type: 'add'}})
      }
    },
    deletCard(row) {
      this.$confirm('确定删除该条数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        api.delVisitor({PsjId : ''+row.psjID}).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            this.getTicket()
          }
        })
      }).catch(() => {});
    },
    resetForm() {
      this.ruleForm={
        tktName: '',
        tktComName: '',
        photo: '',
        tktIDCard: '',
        tktRank: ''
      }
    },
    getTicket() {
      api.getVisitorList({Source:'展商自服务-专业观众',PageIndex:1,PageSize:999999}).then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.sytotal = parseInt(this.num) - parseInt(res.data.data.total)
        }
      })
    },
    editCard(row, type) {
      this.$router.push({path: '/addzygz', query: {type: 'edit', psnID: row.psnID, psjID: row.psjID}})
    }
  }
}
</script>

<style lang="less" scoped>
.activityList{
  .areaClass{
    border-collapse: collapse;
    td{
      border: 1px solid #CCCCCC;
      padding: 10px;
      font-size: 14px;
    }
  }
  .operas{
    text-align: right;
    padding: 20px 0;
  }
  .tipVIP{
    p{
      margin: 5px 0;
    }
  }
  .fileParent {
    position: relative;
    img {
      position: absolute;
      width: 60px;
      height: 39px;
      left: 0;
      top: 0;
    }
  }
  .file {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:120px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>